module.exports = __webpack_public_path__ + "img/transformselect_en.4f315b5.jpg";